import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { getModuleConfiguration } from "../../../store/Checkin/moduleConfigurationSlice";
import { initReactI18next, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {
  getParametersFromLocalStorage,
  getStepMaster,
} from "../../../helpers/commonHelper";
import {
  CONFIG_MASTER_ENUM,
  STEP_MASTER_ENUM,
} from "../../../constants/constant";
const ConfirmSoftChildCountModal = ({
  showConfirmSoftChildCountModal,
  confirmAdultCount,
  closeModal,
  closeAdultModal,
  adultCount,
  childCount,
}) => {
  console.log(
    "ConfirmSoftChildCountModal rendered with adultCount:",
    adultCount,
    "childCount:",
    childCount
  );
  const { t } = useTranslation();

  const [selectedAdultCount, setSelectedAdultCount] = useState(adultCount);
  const [selectedChildCount, setSelectedChildCount] = useState(childCount);
  const [selectedSoftChildCount, setSelectedSoftChildCount] =
    useState(childCount);
  const [isFocused, setIsFocused] = useState(false);
  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const settings = getParametersFromLocalStorage("settings");
  const maxSoftChildCountLimit =
    settings?.find(
      (setting) => setting.parameterName === "MaxSoftChildCountLimit"
    )?.parameterValue ?? "4"; // Default as string
  const stepReservationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  const parsedLimit = parseInt(maxSoftChildCountLimit, 10) || 4;

  const handleSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);

    setSelectedAdultCount(Math.min(selectedValue)); //modified to set it based on adultcount
  };
  const handleAdultSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);

    setSelectedAdultCount(selectedValue);
  };

  useEffect(() => {
    localStorage.setItem("selectedAdultCount", selectedAdultCount.toString());
  }, [selectedAdultCount]);
  useEffect(() => {
    localStorage.setItem("selectedChildCount", selectedChildCount.toString());
  }, [selectedChildCount]);
  console.log("adultCount:", adultCount, typeof adultCount);

  const handleChildSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);

    setSelectedChildCount(Math.min(selectedValue));
  };
  return (
    <div>
      <Modal open={showConfirmSoftChildCountModal} style={{ zIndex: "1" }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "800px",
            backgroundColor: "#f5f5f5",
            border: "2px #000",
            boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
            padding: "70px",
            borderRadius: "20px",
          }}
        >
          <button
            id="btn-adultchildcount-close"
            className="close-icon"
            onClick={closeAdultModal}
            style={{
              position: "absolute",
              top: "18px",
              right: "16px",
              border: "none",
              cursor: "pointer",
            }}
          >
            <CloseIcon style={{ color: "white", fontSize: "24px" }} />
          </button>
          {/* Modal Title */}
          {/* <Typography 
            variant="h6"
            component="h2"
            sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.8rem" }}
          >
            {t("Guest Information")}
          </Typography> */}
          <>
            <Typography
              id="modal-modal-description"
              class="adultconfirm-title"
              sx={{ mt: 2, textAlign: "center", fontSize: "1.8rem" }}
            >
              <p>
                {t(
                  "Please confirm number of adults and children checking in"
                )}
              </p>
            </Typography>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                {/* Label for Adult Count */}
                <label
                  htmlFor="adultCountDropdown"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    marginRight: "8px",
                    fontSize: "1.2rem",
                  }}
                >
                  {t("Adult : ")}
                </label>
                {/* Adult Count Dropdown */}
                <select
                  /* value={selectedAdultCount_Guest}*/
                  value={selectedAdultCount}
                  onChange={handleAdultSelectChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  style={{
                    padding: "10px",
                    width: "100px",
                    border: isFocused
                      ? "2px solid var(--yes-btn-color)"
                      : "2px solid #ced4da",
                    outline: "none",
                    borderRadius: "5px",
                    transition: "border-color 0.2s ease",
                    marginRight: "20px",
                  }}
                >
                  {Array.from({ length: adultCount }, (_, i) => i + 1).map(
                    (count) => (
                      <option key={count} value={count}>
                        {count}
                      </option>
                    )
                  )}
                </select>

                {/* Label for Child Count */}
                <label
                  htmlFor="childCountDropdown"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    marginRight: "8px",
                    fontSize: "1.2rem",
                  }}
                >
                  {t("Child : ")}
                </label>
                {/* Child Count Dropdown */}
                <select
                  value={selectedChildCount}
                  onChange={handleChildSelectChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  style={{
                    padding: "10px",
                    width: "100px",
                    border: isFocused
                      ? "2px solid var(--yes-btn-color)"
                      : "2px solid #ced4da",
                    outline: "none",
                    borderRadius: "5px",
                    transition: "border-color 0.2s ease",
                  }}
                >
                  {Array.from({ length: parsedLimit + 1 }, (_, i) => i).map(
                    (count) => (
                      <option key={count} value={count}>
                        {count}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div style={{ marginBottom: "20px", marginTop: "50px" }}>
                {/* Dynamic Info Text */}
                {/* <Typography
               
                   class="adultconfirm-selection-text"
                
                >
                  {selectedAdultCount || selectedChildCount
                    ? `You have selected ${selectedAdultCount} adult${selectedAdultCount > 1 ? 's' : ''} and ${selectedChildCount} child${selectedChildCount > 1 ? 'ren' : ''}. Click 'Yes' to confirm or 'No' to cancel.`
                    : "Please select the number of adults and children."}
                </Typography> */}
                {/* <button
                  id="btn-adultchildcount-no"
                  style={{
                    marginTop: "20px",
                    padding: "15px",
                    marginLeft: "15px",
                  }}
                  className="btn button-blue guestcount-modal-no-btn"
                  onClick={() => {
                    setSelectedChildCount(childCount); // Revert dropdown
                    setSelectedSoftChildCount(childCount); // Revert soft count
                    localStorage.setItem(
                      "selectedChildCount",
                      childCount.toString()
                    );
                    closeModal();
                    confirmAdultCount(adultCount, childCount); // No update
                  }}
                >
                  {t("Cancel")}
                </button> */}
                <button
                  id="btn-adultchildcount-yes"
                  style={{
                    marginTop: "20px",
                    padding: "15px",
                    marginLeft: "15px",
                  }}
                  className="btn button-blue guestcount-modal-yes-btn"
                  onClick={() => {
                    setSelectedSoftChildCount(selectedChildCount); // Save selected
                    localStorage.setItem(
                      "selectedChildCount",
                      selectedChildCount.toString()
                    );
                    confirmAdultCount(selectedAdultCount, 0); // 0 indicates soft update
                  }}
                >
                  {t("Confirm")}
                </button>
              </div>
            </div>
          </>
          {/* ) } */}
        </Box>
      </Modal>
    </div>
  );
};

export default ConfirmSoftChildCountModal;
